import { Release } from '../types';
import { RecursiveStringifyEnums } from './buildDistro';
import { baseRelease } from '@/testData/baseRelease';

export const baseReleaseAndroid = () => {
    const release: RecursiveStringifyEnums<Release> = {
        ...baseRelease(),
        id: 'demo-android:1.0.0',
        releaseId: '1.0.0',
        releasePilotId: 'demo@demo.com',
        version: '1.0.0',
        displayableVersion: '1.0.0',
        displayableNextVersion: '1.1.0',
        status: 'active',
        timelinePhase: 'current',
        type: 'minor',
        createdAt: '2022-02-08T23:07:39.722790844Z',
        updatedAt: '2022-03-23T00:16:53.271674422Z',
        targetKickoffDate: null,
        targetSubmitDate: null,
        targetReleaseDate: null,
        phasedRelease: null,
        doesBranchExist: true,
        releasedAt: null,
        createdOrigin: 'runwayDraft',
        isKickedOff: true,
        nextVersion: '1.26.0',
        scheduledAutomationsPaused: null,
        isReleaseTagged: false,
        isSubmitted: false,
        isReleased: false,
        overview: {
            codeContributors: [
                {
                    id: '1',
                    firstName: 'Charyl',
                    lastName: 'Tabourier',
                    email: 'ctabourier0@example.com',
                    avatar: 'https://robohash.org/enimperspiciatisvitae.png?size=50x50&set=set1',
                    itemOfWorkCount: 45,
                },
                {
                    id: '2',
                    firstName: 'Lukas',
                    lastName: 'McMorland',
                    email: 'lmcmorland1@example.com',
                    avatar: 'https://robohash.org/quoprovidenthic.png?size=50x50&set=set1',
                    itemOfWorkCount: 23,
                },
                {
                    id: '3',
                    firstName: 'Manon',
                    lastName: 'Willan',
                    email: 'mwillan2@example.com',
                    avatar: 'https://robohash.org/enimperspiciatisvitae.png?size=50x50&set=set1',
                    itemOfWorkCount: 18,
                },
                {
                    id: '4',
                    firstName: 'Sibeal',
                    lastName: 'Neward',
                    email: 'sneward3@example.com',
                    avatar: 'https://robohash.org/vitaefugiatsimilique.png?size=50x50&set=set1',
                    itemOfWorkCount: 42,
                },
                {
                    id: '5',
                    firstName: 'Hagen',
                    lastName: 'Coolican',
                    email: 'hcoolican4@example.com',
                    avatar: 'https://robohash.org/quiquosed.png?size=50x50&set=set1',
                    itemOfWorkCount: 38,
                },
                {
                    id: '6',
                    firstName: 'Eada',
                    lastName: 'Benyan',
                    email: 'ebenyan5@example.com',
                    avatar: 'https://robohash.org/consequuntursimiliquequo.png?size=50x50&set=set1',
                    itemOfWorkCount: 14,
                },
                {
                    id: '7',
                    firstName: 'Bobinette',
                    lastName: 'Herkess',
                    email: 'bherkess6@example.com',
                    avatar: 'https://robohash.org/uttemporibusea.png?size=50x50&set=set1',
                    itemOfWorkCount: 1,
                },
                {
                    id: '8',
                    firstName: 'Asa',
                    lastName: 'Macak',
                    email: 'amacak7@example.com',
                    avatar: 'https://robohash.org/commodivoluptatibusmolestiae.png?size=50x50&set=set1',
                    itemOfWorkCount: 17,
                },
                {
                    id: '9',
                    firstName: 'Hewie',
                    lastName: 'Rawdall',
                    email: 'hrawdall8@example.com',
                    avatar: 'https://robohash.org/quibusdamliberofugiat.png?size=50x50&set=set1',
                    itemOfWorkCount: 2,
                },
                {
                    id: '10',
                    firstName: 'Mona',
                    lastName: 'Lumb',
                    email: 'mlumb9@example.com',
                    avatar: 'https://robohash.org/namcorruptinobis.png?size=50x50&set=set1',
                    itemOfWorkCount: 1,
                },
                {
                    id: '11',
                    firstName: 'Eada',
                    lastName: 'Benyan',
                    email: 'ebenyan5@example.com',
                    avatar: 'https://robohash.org/consequuntursimiliquequo.png?size=50x50&set=set1',
                    itemOfWorkCount: 1,
                },
                {
                    id: '12',
                    firstName: 'Bobinette',
                    lastName: 'Herkess',
                    email: 'bherkess6@example.com',
                    avatar: 'https://robohash.org/uttemporibusea.png?size=50x50&set=set1',
                    itemOfWorkCount: 1,
                },
                {
                    id: '13',
                    firstName: 'Asa',
                    lastName: 'Macak',
                    email: 'amacak7@example.com',
                    avatar: 'https://robohash.org/commodivoluptatibusmolestiae.png?size=50x50&set=set1',
                    itemOfWorkCount: 7,
                },
                {
                    id: '14',
                    firstName: 'Hewie',
                    lastName: 'Rawdall',
                    email: 'hrawdall8@example.com',
                    avatar: 'https://robohash.org/quibusdamliberofugiat.png?size=50x50&set=set1',
                    itemOfWorkCount: 2,
                },
                {
                    id: '15',
                    firstName: 'Mona',
                    lastName: 'Lumb',
                    email: 'mlumb9@example.edu',
                    avatar: 'https://robohash.org/namcorruptinobis.png?size=50x50&set=set1',
                    itemOfWorkCount: 11,
                },
            ],
            contributingTeams: [
                { name: 'analytics', itemOfWorkCount: 8 },
                { name: 'infra', itemOfWorkCount: 1 },
                { name: 'launch', itemOfWorkCount: 10 },
                { name: 'api', itemOfWorkCount: 13 },
                { name: 'ux', itemOfWorkCount: 3 },
            ],
            topChangedFiles: [
                {
                    fileName: 'ContentView.swift',
                    linesChangedCount: 47,
                    isConfigFile: false,
                },
                {
                    fileName: 'FancyMenu.swift',
                    linesChangedCount: 32,
                    isConfigFile: false,
                },
                {
                    fileName: 'Assets.xcassets',
                    linesChangedCount: 12,
                    isConfigFile: false,
                },
            ],
            totalFilesChanged: 3,
            averageAppStoreCrashFreeSessions: 0,
            averageAppStoreCrashFreeUsers: 0,
            averageBetaCrashFreeSessions: 0,
            averageBetaCrashFreeUsers: 0,
            totalAutomationsPerformedCount: 0,
            totalAutomationsScheduledCount: 0,
            estimatedAutomationsTimeSaved: 0,
            estimatedAutomationsCostSaving: 0,
        },
    };
    return release;
};
